var _path, _path2, _path3, _path4, _path5, _path6, _path7, _circle, _path8, _circle2, _path9, _path0, _path1, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLowRatesAndFees(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.063 60.97V46.876L18.375 60.97h7.688zM36.954 60.97H52.33l-6.407-6.406h7.047V43.032l-3.203-4.484L36.954 60.97z",
    fill: "#E1F8F1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.125 43.673v3.203m17.938-6.407V60.97H8.125V50.72",
    stroke: "#376E66",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.845 59.97a1 1 0 110 2v-2zm-21.782 1v1a1 1 0 01-1-1h1zm-1-20.5a1 1 0 012 0h-2zm22.782 21.5H26.063v-2h21.782v2zm-22.782-1v-20.5h2v20.5h-2z",
    fill: "#376E66"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.463 22.532h19.464l-19.464 15.04H3l19.463-15.04z",
    stroke: "#376E66",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M42.527 21.732a1 1 0 00-1.2 1.6l1.2-1.6zm5.877 6.908a1 1 0 101.2-1.6l-1.2 1.6zm-7.077-5.308l7.077 5.308 1.2-1.6-7.077-5.308-1.2 1.6z",
    fill: "#376E66"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "#376E66",
    strokeWidth: 2,
    strokeLinejoin: "round",
    d: "M37.595 37.907h7.688v10.25h-7.688z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M52.646 16.125v.83m17.662 12.373v13.704m-17.662 3.081v8.268h-7.18L61.448 70l15.867-15.62h-2.563M52.646 25.736v-6.171",
    stroke: "#376E66",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 57.454,
    cy: 35.985,
    r: 8.328,
    stroke: "#376E66",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M60.658 32.782l-6.407 6.406M54.892 34.063a.64.64 0 100-1.281.64.64 0 000 1.281zM60.017 39.188a.64.64 0 100-1.281.64.64 0 000 1.281z",
    stroke: "#10C98E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 65.241,
    cy: 51.786,
    r: 6.765,
    fill: "#FFF7EE",
    stroke: "#7E776E",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M64.402 53.17a1 1 0 10-.679 1.88l.68-1.88zm.813 1.146l.006-1h-.005l-.001 1zm1.362-1.005l.987.162-.987-.162zm-.407-1.16l.656-.754-.002-.002-.654.756zm-1.127-.373l-.197.98.008.002.189-.982zm-.881-.455l-.786.617.004.006.782-.623zm-.259-1.002l-.987-.162v.006l.987.156zm1.362-1.005l-.003 1 .003-1zm.79 1.138a1 1 0 00.725-1.864l-.725 1.864zm-1.992 3.656l-.34.94.001.001h.002l.004.002.01.003a4.81 4.81 0 00.448.13c.256.06.627.13 1.026.13l.002-2c-.185 0-.39-.034-.564-.076a3.2 3.2 0 01-.245-.069l-.008-.003h.001l.001.001-.338.94zm1.146 1.206c.844.005 2.133-.495 2.355-1.843l-1.974-.325a.064.064 0 01-.011.03.213.213 0 01-.059.053.575.575 0 01-.3.085l-.011 2zm2.355-1.843a2.275 2.275 0 00-.738-2.076l-1.313 1.509c.05.043.094.14.077.242l1.974.325zm-.74-2.078a2.284 2.284 0 00-.941-.472c-.23-.06-.552-.108-.651-.127l-.378 1.964c.106.02.234.041.311.055.092.016.16.03.218.044.116.03.138.053.133.049l1.307-1.513zm-1.584-.597a1.154 1.154 0 01-.253-.074.225.225 0 01-.043-.025l-1.564 1.247c.452.567 1.084.736 1.466.813l.394-1.961zm-.292-.093a.317.317 0 01-.057-.227l-1.976-.313c-.099.625.072 1.28.46 1.776l1.573-1.236zm-.058-.221a.289.289 0 01.029-.097.025.025 0 01.008-.01c.011-.008.097-.061.335-.06l.007-2c-.518-.002-1.058.11-1.512.438-.474.342-.748.842-.84 1.404l1.973.325zm.372-.168a2.526 2.526 0 01.794.139l.005.002-.002-.001h-.002v-.001h-.002l.362-.933.363-.932h-.002-.001a.315.315 0 01-.015-.007 2.115 2.115 0 00-.127-.044 4.516 4.516 0 00-1.366-.223l-.007 2z",
    fill: "#7E776E"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M65.36 54.73l.001 1.115M65.371 47.727l-.002 1.086",
    stroke: "#7E776E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M59.377 11v9.61M65.57 23.813v3.02",
    stroke: "#10C98E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M65.569 16.125v4.737",
    stroke: "#7E776E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgLowRatesAndFees;